// 校验手机号码
export function checkPhoneNum(str) {
  if (!str) {
    return false;
  }
  let reg = /^1[3-9]\d{9}$/g;
  return reg.test(str);
}

export function getTime(time) {
  //let time="2018-08-24 12:12:12"
  if (time) {
    const timearr = time.split(" ");
    if (timearr.length && timearr[0]) {
      const datearr = timearr[0].split("-");
      return "" + datearr[0] + "年" + datearr[1] + "月" + datearr[2] + "日";
    }
  }
  return null;
}
